// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledIcon } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "common.ui9",
        icon: {
            iconProps: {
                size: 13,
                color: "common.ui9",
                css: css`
                    width: 12px;
                    margin-right: 8px;
                    opacity: 0.66;
                `,
            },
            position: "left",
        },
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 23px;
            `,
        },
        css: css`
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            &:disabled {
                opacity: 0.44;
            }
            &:focus {
                outline: none;
            }

            &:not(:disabled):hover {
                &,
                ${TypographyStyle}, ${IconWrapper}, ${StyledIcon} {
                    color: ${color("common.ui10")};
                    opacity: 1;
                }
            }
        `,
    },
} as xBaseTheme["link"];
